<template>
  <b-container fluid>
    <TopBar id="top-bar" :nom="epreuve.nom_epreuve" :date="epreuve.date_epreuve" :ville="epreuve.ville_competition" :id_epreuve="epreuve.id"></TopBar>
    <!-- Permet de filtrer les résultats -->
    <b-row id="selector-bar">
      <b-col sm="12" md="6">
        <SelectionCourse v-if="epreuve.list_courses" :list_courses="epreuve.list_courses" :id_epreuve="epreuve.id"></SelectionCourse>
      </b-col>
      <b-col sm="12" md="6">
        <SelectionChallenge v-if="epreuve.challenges.length > 0" :current_challenge="current_challenge" :challenges="epreuve.challenges" :id_epreuve="epreuve.id"> </SelectionChallenge>
        <SelectionChallengeEquipe v-if="epreuve.challenges_equipe.length > 0" :current_challenge="current_challenge_equipe" :challenges="epreuve.challenges_equipe" :id_epreuve="epreuve.id"> </SelectionChallengeEquipe>
        <SelectPointIntermediaires v-if="epreuve.passages_inter" :current_passage="current_passage" :current_course="course" :id_epreuve="epreuve.id" :passages="epreuve.passages_inter"></SelectPointIntermediaires>
        <SelectionCourseCumul v-if="epreuve.courses_cumul" :courses_cumul="epreuve.courses_cumul" :current_courses_cumul="current_courses_cumul" :id_epreuve="epreuve.id"></SelectionCourseCumul>
        <SelectionCourseCumulEquipe v-if="epreuve.courses_cumul_equipe" :courses_cumul_equipe="epreuve.courses_cumul_equipe" :current_courses_cumul_equipe="current_courses_cumul_equipe" :id_epreuve="epreuve.id"></SelectionCourseCumulEquipe>
      </b-col>
    </b-row>

    <!-- Fourni les stats d'inscriptions ainsi que les boutons pour télécharger la séléction en PDF et CSV -->
    <b-row id="additional-informations-bar">
      <b-col> </b-col>
      <b-col>
        <span class="filter-title">Télécharger cette sélection : </span>
        <b-button-group>
          <form v-if="epreuve" :action="$store.getters.base_url + '/files/listing_challenge_equipe_pdf.php'" method="POST" target="_blank">
            <input type="hidden" name="epreuve" :value="epreuve.nom_epreuve" />
            <input type="hidden" name="challenge" :value="current_challenge" />
            <input type="hidden" name="date" :value="epreuve.date_epreuve" />
            <input type="hidden" name="data" :value="JSON.stringify(this.resultats_for_pdf)" />

            <b-button type="submit" size="sm"> <v-icon name="download" /> PDF</b-button>
          </form>
        </b-button-group>
      </b-col>
    </b-row>
    <TableauResultatsChallengeEquipe
      id="tableau-resultats"
      v-if="!loading && epreuve.resultats.length > 0 && epreuve.selected_challenge_equipe"
      :resultats="resultats"
      :fields="epreuve.fields"
      :nb_courses="epreuve.selected_challenge_equipe.courses.length"
      :courses_challenge="epreuve.selected_challenge_equipe"
      :colored_fields="epreuve.colored_fields"
      :diplome="epreuve.diplome"
      :nom_epreuve="epreuve.nom_epreuve"
      @updateResultatsChallenge="updateResultatsChallenge"
    ></TableauResultatsChallengeEquipe>

    <AttenteResultats v-if="!loading && epreuve.resultats.length < 1"></AttenteResultats>
    <FullScreenLoading v-if="loading" action="Chargement en cours"></FullScreenLoading>
  </b-container>
</template>

<script>
import axios from "axios";
import TopBar from "@/component/Epreuve/TopBar";
import TableauResultatsChallenge from "@/component/Epreuve/TableauResultatsChallenge";
import TableauResultatsChallengeEquipe from "@/component/Epreuve/TableauResultatsChallengeEquipe";
import TableauResultatsPassages from "@/component/Epreuve/TableauResultatsPassages";
import TableauResultatsEquipe from "@/component/Epreuve/TableauResultatsEquipe";
import SelectionCourse from "@/component/Epreuve/SelectionCourse";
import SelectionChallenge from "@/component/Epreuve/SelectionChallenge";
import SelectionChallengeEquipe from "@/component/Epreuve/SelectionChallengeEquipe";
import FullScreenLoading from "@/component/FullScreenLoading";
import AttenteResultats from "@/component/Epreuve/AttenteResultats";
import SelectPointIntermediaires from "@/component/Epreuve/SelectPointIntermediaires";
import SelectionCourseCumul from "@/component/Epreuve/SelectionCourseCumul";
import SelectionCourseCumulEquipe from "@/component/Epreuve/SelectionCourseCumulEquipe";
import Papa from "papaparse";

export default {
  components: {
    TopBar,
    TableauResultatsChallenge,
    TableauResultatsPassages,
    TableauResultatsEquipe,
    SelectionCourse,
    SelectionChallenge,
    SelectionChallengeEquipe,
    FullScreenLoading,
    AttenteResultats,
    SelectPointIntermediaires,
    TableauResultatsChallengeEquipe,
    SelectionCourseCumul,
    SelectionCourseCumulEquipe,
  },

  data() {
    return {
      loading: true,
      id_epreuve: 0,
      type_course: "normal",
      course: "",
      current_passage: "",
      current_challenge: "",
      current_challenge_equipe: "",
      epreuve: {},
      resultats_equipes: [],
      resultats_for_pdf: [],
      list_cat: [],
      filterCat: "Toutes",
      list_clubs: [],
      filterClub: "Tous",
      filterSexe: "",
      keyword: "",
    };
  },
  computed: {
    resultats() {
      if (!this.epreuve.resultats) {
        return [];
      }
      var filteredTab = this.epreuve.resultats;
      return filteredTab;
    },
  },
  watch: {
    $route: function (newVal, oldVal) {
      // watch it
      this.loading = true;
      this.init();
      this.loadDatas();
    },
  },
  methods: {
    updateResultatsChallenge(res) {
      this.resultats_for_pdf = [];
      this.resultats_equipes = res;
      var iEPDF = [];
      for (var i = 0; i < this.resultats_equipes.length; i++) {
        var equipe = JSON.parse(JSON.stringify(this.resultats_equipes[i]));
        var coureurs = [];
        for (var j = 0; j < equipe.coureurs.length; j++) {
          var c = equipe.coureurs[j];
          coureurs.push([c["Clt"], c["Nom - Prénom"], c["Doss."], c["Clt Cat"], c["Temps"], c["Club"], c["nation"], c["Moy."], c["sexe"], c["Clt Sexe"], c["course"]]);
        }
        equipe.coureurs = coureurs;
        iEPDF.push(equipe);
      }
      this.resultats_for_pdf = iEPDF;
    },
    /* Build data for PDF Export */
    itemsForPdf() {
      var iPDF = [];
      for (var i = 0; i < this.resultats.length; i++) {
        var c = this.resultats[i];
        iPDF.push([c["Clt"], c["Nom - Prénom"], c["Doss."], c["Clt Cat"], c["Temps"], c["Club"], c["nation"], c["Moy."], this.getFirst(c["Temps"]), c["sexe"], c["Clt Sexe"]]);
      }
      return iPDF;
    },
    itemsEquipesForPdf() {
      var iEPDF = [];
      for (var i = 0; i < this.resultats_equipes.length; i++) {
        var equipe = this.resultats_equipes[i];
        var coureurs = [];
        for (var j = 0; j < equipe.coureurs.length; j++) {
          var c = equipe.coureur[j];
          coureurs.push([c["Clt"], c["Nom - Prénom"], c["Doss."], c["Clt Cat"], c["Temps"], c["Club"], c["nation"], c["Moy."], this.getFirst(c["Temps"]), c["sexe"], c["Clt Sexe"]]);
        }
        equipe.coureurs = coureurs;
        iEPDF.push(equipe);
      }
      return iEPDF;
    },
    /* Build data for CSV Export */
    downloadCSV() {
      var dataToCsv = [];
      for (var i = 0; i < this.resultats.length; i++) {
        var r = this.resultats[i];
        var currentFields = this.epreuve.fields;
        var currentData = {};
        for (var j = 0; j < currentFields.length; j++) {
          if (currentFields[j].label === "Ecart") {
            currentData[currentFields[j].label] = this.getFirst(r["Temps"]);
          } else {
            currentData[currentFields[j].label] = r[currentFields[j].label];
          }
        }
        dataToCsv.push(currentData);
      }

      var csv = Papa.unparse(dataToCsv, { delimiter: ";" });

      var csvData = new Blob(["\ufeff", csv], {
        type: "text/csv;charset=utf-8;",
      });
      var csvURL = null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, "download.csv");
      } else {
        csvURL = window.URL.createObjectURL(csvData);
      }

      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", "Résultats-Sportips " + this.epreuve.course + ".csv");
      tempLink.click();
    },
    /* Return time since first runner arrival */
    getFirst(t) {
      if (!this.resultats.length > 0) {
        return 0;
      }
      if (t === this.resultats[0].temps_arrondi || t == null) {
        return "";
      } else {
        var t2 = this.resultats[0].temps_arrondi.split(":");
        var t1 = t.split(":");
        var diff = parseInt(t1[0]) * 3600 + parseInt(t1[1]) * 60 + parseInt(t1[2]) - (parseInt(t2[0]) * 3600 + parseInt(t2[1]) * 60 + parseInt(t2[2]));
        var heure = Math.floor(diff / 3600);
        var heurerest = diff % 3600;
        var minute = Math.floor(heurerest / 60);
        var sec = heurerest % 60;
        var res = "+ " + heure + "h" + minute + "m" + sec + "s";

        return res;
      }
    },
    /* Fetch data from server */
    loadDatas() {
      var _this = this;
      axios.post(this.$store.getters.base_url + "/public/challengeEquipe/get.php?id=" + this.id_epreuve + "&challenge=" + this.current_challenge_equipe).then(function (response) {
        _this.loading = false;
        _this.epreuve = response.data;
        /*
          if (_this.course === "") {
            _this.course = _this.epreuve.list_courses[0];
          }
          _this.build_lists_filters(); */
      });
    },

    /* Créer les liste de categories et clubs pour les filtres */
    build_lists_filters() {
      for (var i = 0; i < this.epreuve.resultats.length; i++) {
        if (!this.list_cat.includes(this.epreuve.resultats[i].abbrev_categorie)) {
          this.list_cat.push(this.epreuve.resultats[i].abbrev_categorie);
        }
        if (!this.list_clubs.includes(this.epreuve.resultats[i].club)) {
          this.list_clubs.push(this.epreuve.resultats[i].club);
        }
      }
      this.list_cat.sort();
      this.list_clubs.sort();
      this.list_cat.unshift("Toutes");
      this.list_clubs.unshift("Tous");
    },
    /* Initialize variables */
    init() {
      this.id_epreuve = this.$route.query.id;
      if (this.$route.query.c) {
        this.current_challenge = this.$route.query.c;
      } else {
        this.current_challenge = "";
      }
      if (this.$route.query.ce) {
        this.current_challenge_equipe = this.$route.query.ce;
      } else {
        this.current_challenge_equipe = "";
      }
      this.list_cat = [];
      this.list_clubs = [];
    },
  },
  mounted: function () {
    const current_query = { ...this.$route.query };
    this.$router.replace({ path: '/epreuve', query: current_query });
    this.init();
    this.loadDatas();
  },
};
</script>

<style>
.isCurrent {
  background-color: white !important;
  color: #f29406 !important;
}
#additional-informations-bar {
  margin-bottom: 5px;
}
#additional-informations-bar p {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
  text-align: left;
  padding-left: 15px;
}
#tableau-resultats {
  font-size: 14px;
}
#table_equipe {
  margin-top: 10px !important;
}
#tableau-resultats td {
  vertical-align: center;
}
.filter-title {
  font-size: 13px;
  margin-bottom: 10px;
  font-weight: bold;
}

#selector-bar {
  background-color: #e2e2e2;
  border: 1px solid #d8d7d7;
  border-radius: 3px;
  margin: 10px 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>

